import Swiper from "swiper/bundle";

const initFixFourSlider = (fixCardsSlider) => {
  if (!(fixCardsSlider instanceof Element) || fixCardsSlider.swiper) {
    return;
  }

  const slides = [...fixCardsSlider.querySelectorAll(".swiper-slide")];
  const controls = fixCardsSlider.querySelector(".swiper-controls");

  const minSlidesForMobileTablet = 2;
  const minSlidesForSmallDesktop = 3;
  const minSlidesForDesktop = 4;

  const shouldInitializeSlider =
    (window.innerWidth < 1024 && slides.length > minSlidesForMobileTablet) ||
    (window.innerWidth >= 1024 &&
      window.innerWidth < 1310 &&
      slides.length > minSlidesForSmallDesktop) ||
    (window.innerWidth >= 1310 && slides.length > minSlidesForDesktop);

  if (!shouldInitializeSlider) {
    if (controls) {
      controls.classList.add("d-none");
    }
    return;
  }

  if (controls) {
    controls.classList.remove("d-none");
  }

  new Swiper(fixCardsSlider, {
    slidesPerView: 2,
    spaceBetween: 12,
    loop: true,
    scrollbar: {
      el: fixCardsSlider.querySelector(".swiper-scrollbar"),
    },
    navigation: {
      nextEl: fixCardsSlider.querySelector(".swiper__button-next"),
      prevEl: fixCardsSlider.querySelector(".swiper__button-prev"),
    },
    breakpoints: {
      768: {
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1310: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });
};

const ProductsSliderFixFour = (root = document) => {
  const scope = root instanceof Element || root === document ? root : document;
  const fixCardsSliders = [
    ...scope.querySelectorAll(".slider-section__slider.fix-four-slides"),
  ];

  fixCardsSliders.forEach((fixCardsSlider) => {
    initFixFourSlider(fixCardsSlider);
  });
};

window.mettevoInitFixFourSliders = ProductsSliderFixFour;

const ProductsSliderFixFourWithResize = () => {
  ProductsSliderFixFour(document);

  window.addEventListener("resize", () => {
    document
      .querySelectorAll(".slider-section__slider.fix-four-slides")
      .forEach((fixCardsSlider) => {
        if (fixCardsSlider.swiper) {
          fixCardsSlider.swiper.destroy(true, true);
        }
      });
    ProductsSliderFixFour(document);
  });
};

export default ProductsSliderFixFourWithResize;
